module.exports = __webpack_public_path__ + "img/services_studya.346d6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/services_studya.png
// module id = 1172
// module chunks = 1